export const setCookie = (cname, cvalue, exdays = 30) => {
	const d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);

	const expires = `expires=${d.toUTCString()}`;
	const value = encodeURIComponent(String(cvalue));
	const secure = window.location.protocol === 'https:' ? '; Secure' : '';

	document.cookie = `${cname}=${value}; ${expires}; path=/; SameSite=Lax${secure}`;
};

export const getCookie = cname => {
	const name = `${cname}=`;
	const ca = document.cookie.split(';');

	for (let i = 0; i < ca.length; i++) {
		const c = ca[i].trim();
		if (c.indexOf(name) === 0) {
			return decodeURIComponent(c.substring(name.length, c.length));
		}
	}
	return '';
};

export const checkCookie = cname => {
	return getCookie(cname);
};
